import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { emailPlaceholder, phone, phoneHref, whatsappHref } from '../data';

export default function ContactCta() {
  return (
    <section id="contact" className="relative overflow-hidden bg-background-50 py-20 md:py-28">
      <div className="absolute right-0 top-0 h-full w-1/2 bg-secondary-100" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 items-center gap-12 px-4 md:px-6">
        <Reveal>
          <SectionLabel>Talk to SRM Textiles</SectionLabel>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
            Looking for Something Traditional?
          </h2>
          <p className="mt-5 max-w-md text-[15px] md:text-base leading-relaxed text-foreground-700">
            Whether you&rsquo;re looking for a saree for a wedding, a dhoti for a celebration
            or traditional clothing for your family, speak with SRM Textiles.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
            <a
              href={phoneHref}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-phone-line" aria-hidden="true" />
              Call SRM Textiles
            </a>
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-whatsapp-line" aria-hidden="true" />
              WhatsApp Us
            </a>
            <a
              href={`mailto:${emailPlaceholder}`}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3.5 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-50"
            >
              <i className="ri-mail-line" aria-hidden="true" />
              Email Us
            </a>
          </div>

          <p className="mt-6 text-[13px] text-foreground-600">
            Prefer to talk? Call us directly on{' '}
            <a href={phoneHref} className="font-semibold text-primary-600">
              {phone}
            </a>
          </p>
        </Reveal>

        <Reveal delay={120} className="lg:pl-10">
          <div className="rounded-lg border border-background-200 bg-background-50 p-8 md:p-10">
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-primary-500">
              Registered Office
            </p>
            <address className="mt-4 not-italic">
              <p className="font-heading text-2xl font-semibold text-foreground-950">SRM Textiles Limited</p>
              <p className="mt-3 text-[15px] leading-relaxed text-foreground-700">
                86 Eastdale Road
                <br />
                Liverpool
                <br />
                England
                <br />
                L15 4HW
              </p>
            </address>
            <div className="mt-6 border-t border-background-200 pt-5">
              <p className="text-[13px] text-foreground-600">
                Company No. <span className="font-semibold text-foreground-900">17367788</span>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}